import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import api from "../../network/apis/api";
import useDebounce from "../../hooks/useDebounce";

export const DropdownWithApiSearch = ({ label, mapOptions, debounceTime = 500, handleSelect, apiObjFunc }) => {
  const [search, setSearch] = useDebounce("", debounceTime);
  const [loading, setLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const mapOptionsRef = useRef(mapOptions);
  const apiObjFuncRef = useRef(apiObjFunc);
  useEffect(() => {
    let isMount = true;
    (async () => {
      const { data: searchResults } = await api.get(apiObjFuncRef.current(search).url, apiObjFuncRef.current(search).query);
      if (isMount) {
        setSearchResults(searchResults.data);
        setLoading(false);
      }
    })();

    return () => {
      isMount = false;
    };
  }, [search]);

  const dropdownOptions = useMemo(() => mapOptionsRef.current(searchResults), [searchResults]);
  return (
    <Dropdown style={{ width: "100%" }} className="mt-0 simple-dropdown-container">
      <Dropdown.Toggle className="bg-white" style={{ width: "100%", border: "1px solid #E4E6EF", textAlign: "left", padding: "0.65rem 1.1rem", background: "white !important" }} variant="transparent">
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "100%" }}>
        <div className="mx-4">
          <Form.Control
            type="text"
            placeholder={"Search..."}
            onChange={(e) => {
              setLoading(true);
              setSearch(e.target.value);
            }}
          />
        </div>
        <Dropdown.Divider />
        {loading ? (
          <div className="w-100 d-flex justify-content-center align-items-center" style={{ minHeight: "25vh" }}>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div style={{ maxHeight: "25vh", position: "relative", overflowY: "auto" }} onClick={(e) => e.stopPropagation()}>
            {dropdownOptions.map((option, optionIndex) => {
              return (
                <Dropdown.Item
                  key={optionIndex}
                  className="dropdown-hover"
                  onSelect={(e) => {
                    handleSelect(option, optionIndex);
                  }}
                >
                  {option.label}
                </Dropdown.Item>
              );
            })}
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
